const globalVariables = {
    selectedApp: 1,
}

export default globalVariables